import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import QrCodeService from './routes/QrCodeService';
import Home from './routes/Home/Home';
import Intro from './routes/Introduction/Intro';
import ManualPage from './routes/Manual';
import Service from './routes/Service';
import Npi from './routes/Npi';

import styles from './App.scss';

import 'config/i18n';
import 'utils/i18n';

function App() {
  return (
    <div className={styles.body}>
      <Router basename="/">
        <Home>
          <Routes>
            <Route path="/" element={<Intro />} />
            <Route path="services/">
              <Route path="details/:serviceId" element={<Service />} />
            </Route>
            <Route path="references/" element={<ManualPage />} />
            <Route path="qr/" element={<QrCodeService />} />
            <Route path="test-npi/" element={<Npi />} />
          </Routes>
        </Home>
      </Router>
    </div>
  );
}

export default App;
